<template>
  <div id="topLeft2">
    <div class="bg-color-black">
      <div class="cc-header">
        <div>各学校收费率</div>
      </div>
      <div class="d-flex jc-center">
        <div id="lineChart" class="lineChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
const echarts = require("echarts");
let pageSize = 8; //echarts每页显示数量
export default {
  data() {
    return {
      start: 0,
      end: pageSize - 1,
      total: 0,
    };
  },
  mounted() {
    this.initData();
    // 定时器刷新，1分钟
    let _this = this;
    setInterval(() => {
      _this.initData();
    }, 1000 * 60);
    // 定时器轮播，5秒
    setInterval(() => {
      _this.dataZoomAutoScoll();
    }, 1000 * 5);
  },
  methods: {
    //echarts图标数据过多时，x轴自动滑动
    dataZoomAutoScoll() {
      let myChart = echarts.init(document.getElementById("lineChart"));
      const max = this.total - 1;
      if (pageSize < this.total) {
        if (this.end > max || this.start > max - pageSize) {
          this.start = 0;
          this.end = pageSize - 1;
        } else {
          this.start += 1;
          this.end += 1;
        }
        myChart.dispatchAction({
          type: "dataZoom",
          dataZoomIndex: 0,
          startValue: this.start,
          endValue: this.end,
        });
      }
    },
    initData() {
      let _this = this;
      let myChart = echarts.init(document.getElementById("lineChart"));
      this.$http.get("/dataView/pay/getRateByOrg").then((res) => {
        if (res.data.code === 200) {
          var result = res.data.result;
          _this.total = result.xDatas.length;
          var option = {
            dataZoom: [
              {
                type: "inside",
                startValue: _this.start,
                endValue: _this.end,
              },
            ],
            xAxis: {
              type: "category",
              axisLine: {
                lineStyle: {
                  color: "#d8d8d8",
                },
              },
              axisLabel: {
                interval: 0,
                rotate: -35, // 角度
                formatter: function (value) {
                  return value.length > 6 ? value.slice(0, 6) + "..." : value;
                },
                textStyle: {
                  fontSize: fontSize(0.27),
                },
              },
              data: result.xDatas,
            },
            grid: {
              left: "12%", // 调整左侧边距
              y: 22, //解决Y轴手机端坐标显示不全
              height: "50%",
            },
            yAxis: {
              type: "value",
              name: "",
              nameTextStyle: {
                padding: [0, 0, 10, 35],
                fontSize: fontSize(0.27),
              },
              axisLine: {
                lineStyle: {
                  color: "#d8d8d8",
                },
              },
              axisLabel: {
                width: 160, // 设置标签宽度
                overflow: "truncate", // 超出部分截断
                truncate: "...", // 截断部分用...代替,z
                formatter: "{value}%",
                textStyle: {
                  fontSize: fontSize(0.27),
                },
              },
              splitLine: {
                show: false,
              },
            },
            series: [
              {
                data: result.yDatas,
                type: "line",
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(2, 0, 0, 1, [
                      {
                        offset: 0,
                        color: "#ead516",
                      },
                      {
                        offset: 0.5,
                        color: "#550962",
                      },
                      {
                        offset: 1,
                        color: "#2d0d6c",
                      },
                    ]),
                  },
                },
                axisLabel: {
                  formatter: "{value}%",
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      position: "top",
                      formatter: "{c}%",
                      textStyle: {
                        color: "#FF9800",
                        fontSize: fontSize(0.25),
                      },
                    },
                  },
                },
              },
            ],
          };
        }
        myChart.hideLoading(); //没有加载出来隐藏加载动画
        myChart.setOption(option);

        // 响应式变化
        window.addEventListener("resize", () => myChart.resize(), false);
      });
    },
  },
  destroyed() {
    window.onresize = null;
  },
};

function fontSize(res) {
  let clientWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (!clientWidth) return;
  let fontSize = 100 * (clientWidth / 750);
  return res * fontSize;
}
</script>

<style lang="scss">
#topLeft2 {
  height: 32vh;

  .cc-header {
    height: 0.5rem;
    padding-top: 1rem;
    color: #fff;
    font-size: 0.55rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .lineChart {
    width: 11.5rem;
    height: 9rem;
    margin-top: 0.5rem;
  }
}
</style>